"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const ProductDisplay_1 = require("./ProductDisplay");
const Product_1 = require("./Models/Product");
const Brand_1 = require("./Models/Brand");
const Category_1 = require("./Models/Category");
const SubcategoryDisplay_1 = require("./SubcategoryDisplay");
const Store_1 = require("./Store");
require("jquery");
const mobx_react_1 = require("mobx-react");
function createProductsApp(components) {
    const { ProductListComponent, BrandListComponent, CategoryListComponent, useProductFilterRoutes } = components;
    let ProductsApp = class ProductsApp extends React.Component {
        constructor(props) {
            super(props);
            Store_1.default.containerId = this.props.containerId;
            Store_1.default.currentPageName = this.props.currentPageName;
            Store_1.default.containerUrlSegment = this.props.containerUrlSegment;
            Store_1.default.containerName = this.props.containerName;
            Store_1.default.Translations = this.props.translations;
            Store_1.default.BackgroundImageUrl = this.props.backgroundImageUrl;
            Store_1.default.DimFilter = this.props.dimFilter || false;
            Store_1.default.currentLanguage = this.props.currentLanguage;
            Store_1.default.readMoreLink = this.props.readMoreLink;
            Store_1.default.disableBrands = this.props.disableBrands || false;
            Store_1.default.disableCategories = this.props.disableCategories || false;
            Store_1.default.loadCategories();
            if (this.props.selectedProduct !== null) { //Landing on ProductDisplay(ProductPage)
                Store_1.default.SelectedProduct = new Product_1.default({ id: this.props.selectedProduct });
                Store_1.default.SelectedProduct.loadDetails();
                Store_1.default.loadBrands();
                Store_1.default.loadCategories();
            }
            if (this.props.selectedBrand !== null) { //Landing on ProductList(ProductBrandPage)
                Store_1.default.SelectedBrand = new Brand_1.default(this.props.selectedBrand);
                Store_1.default.loadProducts();
            }
            else if (this.props.selectedCategories !== null && this.props.selectedCategories.length > 0) {
                Store_1.default.SelectedCategories.replace(this.props.selectedCategories.map(json => new Category_1.default(json)));
                Store_1.default.loadProducts();
            }
            if (this.props.selectedCategory !== null) { //Landing on BrandList(ProductCategoryPage)
                Store_1.default.SelectedCategory = this.props.selectedCategory;
                if (!useProductFilterRoutes) {
                    Store_1.default.loadBrandsByCategory();
                    Store_1.default.loadSubcategories();
                }
            }
            if (this.props.selectedSubcategory !== null) { //Landing on Subcategory(SubcategoryPage)
                Store_1.default.SelectedSubcategory = this.props.selectedSubcategory;
                Store_1.default.loadProducts();
            }
            window.onpopstate = function () {
                location.reload();
            };
        }
        render() {
            if (useProductFilterRoutes) {
                return (React.createElement(react_router_dom_1.BrowserRouter, null,
                    React.createElement(react_router_dom_1.Switch, null,
                        React.createElement(react_router_dom_1.Route, { exact: true, path: Store_1.default.containerUrlSegment, component: Store_1.default.disableBrands ? ProductListComponent : BrandListComponent }),
                        Store_1.default.disableBrands && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories/:product", component: ProductDisplay_1.default }),
                        Store_1.default.disableBrands && Store_1.default.disableCategories && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":product", component: ProductDisplay_1.default }),
                        React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories/:brand/:product", component: ProductDisplay_1.default }),
                        React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories", component: ProductListComponent }))));
            }
            return (React.createElement(react_router_dom_1.BrowserRouter, null,
                React.createElement(react_router_dom_1.Switch, null,
                    Store_1.default.SelectedSubcategory && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":category/" + Store_1.default.SelectedSubcategory.containerUrlSegment + "/:subcategory", component: SubcategoryDisplay_1.default }),
                    Store_1.default.disableBrands && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":categories/:product", component: ProductDisplay_1.default }),
                    Store_1.default.disableBrands && Store_1.default.disableCategories && React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":product", component: ProductDisplay_1.default }),
                    React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":category/:brand/:product", component: ProductDisplay_1.default }),
                    React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":category/:brand", component: ProductListComponent }),
                    React.createElement(react_router_dom_1.Route, { path: Store_1.default.containerUrlSegment + ":category", component: BrandListComponent }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: Store_1.default.containerUrlSegment, component: Store_1.default.disableBrands ? ProductListComponent : CategoryListComponent }))));
        }
    };
    ProductsApp = __decorate([
        mobx_react_1.observer
    ], ProductsApp);
    return ProductsApp;
}
exports.default = createProductsApp;
